import auth from './_auth.js';
const _actions = {
  auth
};
export default _actions;
